<template>
    <div class="internet-renewal-table">
        <v-data-table :loading="loader" disable-initial-sort :rows-per-page-items="rowPerPage" :headers="headers"
            class="custom-data-table" :items="grouped_items" item-key="_id">
            <template #headers="props">
                <tr class="first-header">
                    <th :class="['text-center', getHeaderClass('checkbox')]">
                        <v-checkbox v-model="selectAll" @change="toggleSelectAll" color="primary"
                            hide-details></v-checkbox>
                    </th>
                    <th :class="['fw-bold', `text-xs-${header.align}`, getHeaderClass(header.value)]"
                        v-for="header in props.headers.slice(1)" :key="header.text">{{ header.text }}</th>
                </tr>
            </template>
            <template #items="props">
                <tr>
                    <td :class="['text-center', 'text-no-wrap']" @click.stop>
                        <v-checkbox v-model="selected_items" :value="props.item._id" color="primary"
                            hide-details></v-checkbox>
                    </td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.index + 1 }}</td>
                    <td :class="['text-left', 'text-no-wrap']">{{ props.item.user }}</td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.renewal_start_date | formatTimeServer }}
                    </td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.renewal_end_date | formatTimeServer }}
                    </td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.renewal_next_date | formatTimeServer }}
                    </td>
                    <td :class="['text-center', 'text-no-wrap']">
                        <span :class="['v-badge', internet_status[props.item.status].badge]">{{
                            internet_status[props.item.status].text }}</span>
                    </td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.package_name || '' }}</td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.speed_mbps || '' }}</td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.price | formatNumber }}</td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.discount_percent ?
                        props.item.discount_percent +
                        '%' : '' }}</td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.additional_discount ?
                        props.item.additional_discount + '%' : '' }}</td>
                    <td :class="['text-center', 'text-no-wrap']">
                        <v-edit-dialog lazy @save="saveManualDiscountAmount(props.item)">
                            <template v-slot:default>
                                <div>{{ (props.item.manual_discount_amount !== undefined && props.item.manual_discount_amount !== null) ? (props.item.manual_discount_amount | formatNumber) : '' }}</div>
                            </template>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="props.item.manual_discount_amount"
                                    label="Số tiền được giảm"
                                    type="number"
                                    single-line
                                    @input="updateVnptPrice(props.item)"
                                    @blur="saveManualDiscountAmount(props.item)"
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                    <td :class="['text-center', 'text-no-wrap']">{{ Math.round(props.item.vnpt_monthly_price ||
                        calculateVnptPrice(props.item)) | formatNumber }}</td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.renewal_package_months || '' }}</td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.gifted_months || '' }}</td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.building_text }}</td>
                    <td :class="['text-center', 'text-no-wrap']">{{ props.item.room_id }}</td>
                </tr>
            </template>
            <template #no-data>Chưa có thông tin</template>
        </v-data-table>


        <!-- Dialog gia hạn -->
        <v-dialog v-model="renewal_dialog" max-width="80vw" style="overflow: auto;">
            <v-card>
                <v-card-title>
                    Gia hạn Internet
                </v-card-title>
                <v-card-text style="max-height: 600px; overflow-y: auto;">
                    <p>Bạn đang chọn <strong>{{ modalItems.length }}</strong> user để gia hạn</p>

                    <!-- Phần chỉnh sửa hàng loạt -->
                    <v-card class="mb-4" elevation="2">
                        <v-card-title class="py-2">
                            <span class="subtitle-1">Chỉnh sửa tất cả dòng</span>
                        </v-card-title>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md2>
                                    <v-text-field v-model="bulkEdit.renewal_package_months" label="Số tháng gia hạn"
                                        type="number" prepend-icon="schedule"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                    <v-text-field v-model="bulkEdit.discount_percent" label="Chiết khấu (%)"
                                        type="number" prepend-icon="percent"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                    <v-text-field v-model="bulkEdit.additional_discount" label="Giảm thêm (%)"
                                        type="number" prepend-icon="percent"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                    <v-text-field v-model="bulkEdit.manual_discount_amount" label="Số tiền được giảm"
                                        type="number" prepend-icon="money_off"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                    <v-text-field v-model="bulkEdit.gifted_months" label="Số tháng được tặng"
                                        type="number" prepend-icon="card_giftcard"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                    <v-menu v-model="bulkEdit.datePickerOpen" :close-on-content-click="false"
                                        transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="bulkEdit.renewal_next_date"
                                                label="Ngày gia hạn tiếp theo" prepend-icon="event" readonly
                                                v-bind="attrs" v-on="on">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="bulkEdit.renewal_next_date"
                                            @input="bulkEdit.datePickerOpen = false" no-title>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12>
                                    <v-btn color="primary" @click="applyBulkEdit" :disabled="!hasBulkEditData">
                                        Áp dụng cho tất cả
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>

                    <!-- Bảng danh sách user được chọn -->
                    <div class="table-container">
                        <v-data-table :headers="renewal_headers" :items="modalItems" hide-actions
                            class="elevation-1 renewal-table">
                            <template #items="props">
                                <td>{{ props.item.user }}</td>
                                <td>{{ props.item.room_id }}</td>
                                <td>
                                    <v-text-field style="padding-bottom: 20px" v-model="props.item.renewal_package_months" type="number" dense
                                        hide-details @input="calculateRenewalEndDate(props.item)"></v-text-field>
                                </td>
                                <td>
                                    <v-text-field style="padding-bottom: 20px" v-model="props.item.discount_percent" type="number" dense
                                        hide-details></v-text-field>
                                </td>
                                <td>
                                    <v-text-field style="padding-bottom: 20px" v-model="props.item.additional_discount" type="number" dense
                                        hide-details></v-text-field>
                                </td>
                                <td>
                                    <v-edit-dialog lazy @save="saveManualDiscountAmount(props.item)">
                                        <div>{{ (props.item.manual_discount_amount !== undefined && props.item.manual_discount_amount !== null) ? (props.item.manual_discount_amount | formatNumber) : '' }}</div>
                                        <template v-slot:input>
                                            <v-text-field
                                                v-model="props.item.manual_discount_amount"
                                                type="number" dense hide-details 
                                                @input="updateVnptPrice(props.item)"
                                                @blur="saveManualDiscountAmount(props.item)"
                                            ></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td>
                                    <v-text-field style="padding-bottom: 20px" v-model="props.item.gifted_months" type="number" dense hide-details @input="calculateRenewalEndDate(props.item)"></v-text-field>
                                </td>
                                <td>
                                    <v-menu style="padding-bottom: 20px" v-model="props.item.datePickerOpen" :close-on-content-click="false"
                                        transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :value="formatDateToLocalString(props.item.renewal_next_date)"
                                                prepend-icon="event" readonly v-bind="attrs" v-on="on" dense
                                                hide-details>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="props.item.renewal_next_date"
                                            @input="props.item.datePickerOpen = false" no-title>
                                        </v-date-picker>
                                    </v-menu>
                                </td>
                                <td>
                                    {{ Math.round(props.item.vnpt_monthly_price || calculateVnptPrice(props.item)) | formatNumber }}
                                </td>
                                <td>
                                    {{ formatDateToLocalString(calculateRenewalStartDateDisplay(props.item)) }}
                                </td>
                                <td>
                                    {{ formatDateToLocalString(props.item.renewal_end_date || calculateRenewalEndDateDisplay(props.item)) }}
                                </td>
                            </template>
                            <template #footer>
                                <tr>
                                    <td colspan="8" class="text-right font-weight-bold">TỔNG CỘNG:</td>
                                    <td class="text-left font-weight-bold" style="text-indent: 16px;">{{ totalAmount |
                                        formatNumber }} VNĐ</td>
                                    <td colspan="4"></td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeRenewalDialog">Hủy</v-btn>
                    <v-btn color="primary" @click="updateOnly">Chỉnh sửa</v-btn>
                    <v-btn color="primary" @click="confirmRenewal">Chỉnh sửa và gia hạn</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <export-csv-button :trigger="export_csv.trigger" :title="export_csv.title"
            :rows="export_csv.rows"></export-csv-button>
    </div>
</template>

<script>
import api from "Api";
import ExportCsvButton from "Components/ExportExcel/ExportCsvButton";
import { list_building, WIFI_TYPES, WIFI_TYPE_BADGES } from "Constants/db-config";
import { formatTimeServer } from "Helpers";
import { INTERNET_REGISTRATION_STATUS } from "Constants/db-config";
import moment from "moment";

export default {
    props: {
        reload_table: Number,
        search: String,
        chosen_building: String,
        exportCSV: Number,
        renewal_date_filter: String
    },
    components: {
        ExportCsvButton
    },
    name: "internet-renewal-table",
    data() {
        return {
            headers: [
                {
                    text: "",
                    align: "center",
                    sortable: false,
                    value: "checkbox"
                },
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "stt"
                },
                {
                    text: "User",
                    align: "left",
                    sortable: true,
                    value: "user"
                },
                {
                    text: "Ngày bắt đầu gia hạn",
                    align: "center",
                    sortable: true,
                    value: "renewal_start_date"
                },
                {
                    text: "Ngày kết thúc gia hạn",
                    align: "center",
                    sortable: true,
                    value: "renewal_end_date"
                },
                {
                    text: "Ngày gia hạn tiếp theo",
                    align: "center",
                    sortable: true,
                    value: "renewal_next_date"
                },
                {
                    text: "Trạng thái",
                    align: "center",
                    sortable: true,
                    value: "status"
                },
                {
                    text: "Tên gói cước",
                    align: "center",
                    sortable: true,
                    value: "package_name"
                },
                {
                    text: "Tốc độ (Mbps)",
                    align: "center",
                    sortable: true,
                    value: "speed_mbps"
                },
                {
                    text: "Giá gói cước",
                    align: "center",
                    sortable: true,
                    value: "price"
                },
                {
                    text: "Chiết khấu",
                    align: "center",
                    sortable: true,
                    value: "discount_percent"
                },
                {
                    text: "Giảm",
                    align: "center",
                    sortable: true,
                    value: "additional_discount"
                },
                {
                    text: "Số tiền được giảm",
                    align: "center",
                    sortable: true,
                    value: "manual_discount_amount"
                },
                {
                    text: "Giá sau khi CK và giảm",
                    align: "center",
                    sortable: true,
                    value: "vnpt_monthly_price"
                },
                {
                    text: "Số tháng gia hạn",
                    align: "center",
                    sortable: true,
                    value: "renewal_package_months"
                },
                {
                    text: "Số tháng được tặng",
                    align: "center",
                    sortable: true,
                    value: "gifted_months"
                },
                {
                    text: "Tòa nhà",
                    align: "center",
                    sortable: true,
                    value: "building"
                },
                {
                    text: "Phòng hiện tại",
                    align: "center",
                    sortable: true,
                    value: "room_id"
                }
            ],
            items: [],
            loader: false,
            rowPerPage: [50, 100, 200, { text: "Tất cả", value: -1 }],
            selected_items: [],
            renewal_dialog: false,
            renewal_months: 1,
            selected_for_renewal: [],
            modalItems: [],
            bulkEdit: {
                renewal_package_months: '',
                discount_percent: '',
                additional_discount: '',
                gifted_months: '',
                renewal_next_date: '',
                vnpt_monthly_price: '',
                manual_discount_amount: '',
                datePickerOpen: false
            },
            export_csv: {
                loading: false,
                trigger: false,
                title: "",
                rows: []
            },
            internet_status: {
                0: {
                    text: "Mạng trống",
                    badge: "error"
                },
                1: {
                    text: "Đang hoạt động",
                    badge: "primary"
                },
                2: {
                    text: "Trả phòng",
                    badge: "warning"
                },
            },
            renewal_headers: [
                { text: "User", value: "user" },
                { text: "Phòng", value: "room_id" },
                { text: "Số tháng gia hạn", value: "renewal_package_months" },
                { text: "Chiết khấu (%)", value: "discount_percent" },
                { text: "Giảm thêm (%)", value: "additional_discount" },
                { text: "Số tiền được giảm", value: "manual_discount_amount" },
                { text: "Số tháng tặng", value: "gifted_months" },
                { text: "Ngày gia hạn tiếp theo", value: "renewal_next_date" },
                { text: "Số tiền từng user", value: "vnpt_monthly_price" },
                { text: "Ngày bắt đầu gia hạn", value: "renewal_start_date" },
                { text: "Ngày kết thúc gia hạn", value: "renewal_end_date" }
            ],
            wifi_type_badges: WIFI_TYPE_BADGES,
            INTERNET_REGISTRATION_STATUS
        };
    },
    computed: {
        filtered_items() {
            const search = this.search && this.search.toLowerCase();
            return this.items.filter(item => {
                // Filter theo building và search
                let buildingMatch = false;
                if (
                    item.building &&
                    item.room_id &&
                    item.building.includes(this.chosen_building) &&
                    item.room_id.toLowerCase().includes(search)
                )
                    buildingMatch = true;
                if (item.user && item.user.includes(search))
                    buildingMatch = item.building && item.building.includes(this.chosen_building);

                if (!buildingMatch) return false;

                // Filter theo tháng gia hạn tiếp theo
                if (this.renewal_date_filter) {
                    if (!item.renewal_next_date) return false;
                    const renewalM = moment(item.renewal_next_date);
                    const filterM = moment(this.renewal_date_filter);
                    if (!renewalM.isValid() || !filterM.isValid()) return false;
                    if (renewalM.month() !== filterM.month() || renewalM.year() !== filterM.year()) {
                        return false;
                    }
                }

                return true;
            });
        },
        grouped_items() {
            const userGroups = {};

            this.filtered_items
                .filter(item => item.wifi_type !== WIFI_TYPES.AUXILIARY)
                .forEach(item => {
                    const key = `${item.user}_${item.room_id}_${item.wifi_type}`;
                    if (!userGroups[key]) {
                        userGroups[key] = item;
                    }
                });

            return Object.values(userGroups).sort((a, b) => {
                if (a.building !== b.building) {
                    return a.building.localeCompare(b.building);
                }
                if (a.user !== b.user) {
                    return a.user.localeCompare(b.user);
                }
                if (a.wifi_type !== b.wifi_type) {
                    const order = { 'main': 1, 'private': 2 };
                    return (order[a.wifi_type] || 99) - (order[b.wifi_type] || 99);
                }
                return a.room_id.localeCompare(b.room_id);
            });
        },
        selectAll: {
            get() {
                return this.grouped_items.length > 0 && this.selected_items.length === this.grouped_items.length;
            },
            set(value) {
                this.selected_items = value ? this.grouped_items.map(item => item._id) : [];
            }
        },
        selectedItemsObjects() {
            return this.grouped_items.filter(item => this.selected_items.includes(item._id));
        },
        totalAmount() {
            const items = this.renewal_dialog ? this.modalItems : this.selectedItemsObjects;
            return items.reduce((total, item) => {
                const amount = item.vnpt_monthly_price || this.calculateVnptPrice(item);
                return total + (Number(amount) || 0);
            }, 0);
        },
        averageAmount() {
            if (this.selectedItemsObjects.length === 0) return 0;
            return this.totalAmount / this.selectedItemsObjects.length;
        },
        hasBulkEditData() {
            return this.bulkEdit.renewal_package_months !== '' ||
                this.bulkEdit.discount_percent !== '' ||
                this.bulkEdit.additional_discount !== '' ||
                this.bulkEdit.gifted_months !== '' ||
                this.bulkEdit.renewal_next_date !== '' ||
                this.bulkEdit.manual_discount_amount !== '' ||
                this.bulkEdit.vnpt_monthly_price !== ''
        }
    },
    watch: {
        reload_table() {
            this.getData();
        },
        exportCSV() {
            this.startExportCSV();
        },
        selected_items: {
            handler(newVal) {
                this.$emit('selection-changed', newVal.length);
            },
            deep: true
        },
        renewal_dialog(newVal) {
            if (!newVal) {
                this.modalItems = [];
            }
        }
    },
    methods: {
        getData: async function () {
            this.items = [];
            this.loader = true;
            try {
                let data = await api.getListInternet();
                this.loader = false;

                if (data.status === 200 && data.data && data.data.internet) {
                    this.items = data.data.internet
                        .map(item => {
                            item.status = this.updateItemStatus(item);
                            return item;
                        })
                        .filter(item => ![INTERNET_REGISTRATION_STATUS.CANCELLED, INTERNET_REGISTRATION_STATUS.PENDING].includes(item.registration_status))
                        .map(item => {
                            const building = list_building.find(
                                building => building.value == item.building
                            );
                            item.building_text = building ? building.text : item.building;

                            if (!item.wifi_type) item.wifi_type = WIFI_TYPES.PRIVATE;
                            if (!item.customer_price) item.customer_price = item.price || 0;

                            return item;
                        });
                } else {
                    console.log("Lỗi lúc tải internet:", data);
                }
            } catch (error) {
                this.loader = false;
                console.error("Lỗi getData:", error);
            }
        },

        updateItemStatus: function (item) {
            if (!item.room_state_id) return 0;
            else if (!item.date_schedule_out) return 1;
            return 2;
        },

        getHeaderClass(headerValue) {
            if (['stt', 'user', 'renewal_start_date', 'renewal_end_date', 'renewal_next_date'].includes(headerValue)) {
                return 'header-blue';
            }
            if (['status', 'package_name', 'speed_mbps'].includes(headerValue)) {
                return 'header-pink';
            }
            if (['price', 'discount_percent', 'additional_discount', 'manual_discount_amount', 'vnpt_monthly_price'].includes(headerValue)) {
                return 'header-orange';
            }
            if (['renewal_package_months', 'gifted_months', 'building', 'room_id'].includes(headerValue)) {
                return 'header-green';
            }
            return '';
        },
        // Format date thành DD/MM/YYYY theo local timezone (không dùng UTC)
        formatDateToLocalString(date) {
            if (!date) return '';
            return moment(date).format('DD/MM/YYYY');
        },
        /** Trong modal: v-date-picker luôn dùng YYYY-MM-DD — chỉ đổi sang DD/MM khi hiển thị. */
        toPickerDate(value) {
            if (!value) return '';
            const m = moment(value);
            return m.isValid() ? m.format('YYYY-MM-DD') : '';
        },
        calculateRenewalEndDate(item) {
            const renewalMonths = Number(item.renewal_package_months) || 0;
            const giftedMonths = Number(item.gifted_months) || 0;
            const totalMonths = renewalMonths + giftedMonths;

            const hasOriginalDate = item.original_renewal_end_date || item.original_renewal_start_date;
            let startDate = null;

            if (item.original_renewal_end_date && moment(item.original_renewal_end_date).isValid()) {
                startDate = moment(item.original_renewal_end_date).toDate();
            } else if (hasOriginalDate && item.renewal_end_date && moment(item.renewal_end_date).isValid()) {
                startDate = moment(item.renewal_end_date).toDate();
            } else if (!hasOriginalDate) {
                if (item.initial_renewal_start_date && moment(item.initial_renewal_start_date).isValid()) {
                    startDate = moment(item.initial_renewal_start_date).toDate();
                } else {
                    startDate = new Date();
                    this.$set(item, 'initial_renewal_start_date', moment(startDate).format('YYYY-MM-DD'));
                }
            } else if (item.renewal_start_date && moment(item.renewal_start_date).isValid()) {
                startDate = moment(item.renewal_start_date).toDate();
            } else {
                startDate = new Date();
            }

            if (totalMonths > 0) {
                const endM = moment(startDate).clone().add(totalMonths, 'months');
                this.$set(item, 'renewal_start_date', moment(startDate).format('YYYY-MM-DD'));
                this.$set(item, 'renewal_end_date', endM.format('YYYY-MM-DD'));
                this.$set(item, 'renewal_next_date', endM.clone().subtract(1, 'day').format('YYYY-MM-DD'));
            } else {
                if (!item.renewal_package_months && !item.gifted_months) {
                    if (item.original_renewal_end_date && moment(item.original_renewal_end_date).isValid()) {
                        this.$set(item, 'renewal_end_date', moment(item.original_renewal_end_date).format('YYYY-MM-DD'));
                    } else {
                        this.$set(item, 'renewal_end_date', '');
                    }
                    if (item.initial_renewal_start_date) {
                        this.$set(item, 'initial_renewal_start_date', null);
                    }
                }
            }
        },
        calculateRenewalStartDateDisplay(item) {
            // Trong modal, hiển thị ngày bắt đầu gia hạn mới = ngày kết thúc cũ (để xem trước)
            // Nếu đã có số tháng gia hạn, ngày bắt đầu mới = ngày kết thúc cũ
            if (item.renewal_package_months || item.gifted_months) {
                // Nếu renewal_start_date đã được cập nhật bởi calculateRenewalEndDate, dùng nó
                if (item.renewal_start_date) {
                    return item.renewal_start_date;
                }
                // Nếu chưa được cập nhật, dùng original_renewal_end_date (ngày kết thúc cũ từ database)
                if (item.original_renewal_end_date) {
                    return item.original_renewal_end_date;
                }
                // Fallback: dùng renewal_end_date hiện tại
                if (item.renewal_end_date) {
                    return item.renewal_end_date;
                }
            }
            // Nếu chưa có số tháng, hiển thị giá trị gốc
            return item.renewal_start_date || '';
        },
        calculateRenewalEndDateDisplay(item) {
            const renewalMonths = Number(item.renewal_package_months) || 0;
            const giftedMonths = Number(item.gifted_months) || 0;
            const totalMonths = renewalMonths + giftedMonths;
            
            if (item.renewal_end_date) {
                return item.renewal_end_date;
            }
            
            if (totalMonths > 0 && item.renewal_start_date) {
                const m = moment(item.renewal_start_date);
                if (!m.isValid()) return item.renewal_end_date || '';
                return m.clone().add(totalMonths, 'months').format('YYYY-MM-DD');
            }
            
            return item.renewal_end_date || '';
        },
        openRenewalDialog() {
            this.modalItems = this.selectedItemsObjects.map(item => {
                const copy = JSON.parse(JSON.stringify(item));
                // Snapshot ISO từ API trước khi chuẩn hóa (tránh lưu nhầm DD/MM vào original)
                copy.original_renewal_end_date = copy.renewal_end_date || null;
                copy.original_renewal_start_date = copy.renewal_start_date || null;
                copy.renewal_next_date = this.toPickerDate(copy.renewal_next_date);
                copy.renewal_end_date = this.toPickerDate(copy.renewal_end_date);
                copy.renewal_start_date = this.toPickerDate(copy.renewal_start_date);
                copy._id = item._id;
                copy.datePickerOpen = false;
                return copy;
            });
            this.renewal_dialog = true;
            this.$nextTick(() => {
                this.modalItems.forEach(item => {
                    if (item.renewal_package_months || item.gifted_months) {
                        if (item.original_renewal_end_date) {
                            item.renewal_end_date = this.toPickerDate(item.original_renewal_end_date);
                        }
                        if (item.original_renewal_start_date) {
                            item.renewal_start_date = this.toPickerDate(item.original_renewal_start_date);
                        }
                        this.calculateRenewalEndDate(item);
                    }
                });
            });
        },
        closeRenewalDialog() {
            this.renewal_dialog = false;
            // Reset modalItems để không ảnh hưởng đến bảng chính
            // Xóa initial_renewal_start_date khi đóng dialog để reset về trạng thái ban đầu
            this.modalItems.forEach(item => {
                if (item.initial_renewal_start_date) {
                    delete item.initial_renewal_start_date;
                }
            });
            this.modalItems = [];
        },
        applyBulkEdit() {
            this.modalItems.forEach((item, index) => {
                let needUpdatePrice = false;
                let needUpdateRenewalDates = false;
                const hasBulkRenewalNextDate = this.bulkEdit.renewal_next_date !== '';
                let savedRenewalNextDate = null;
                
                if (this.bulkEdit.renewal_package_months !== '') {
                    this.$set(item, 'renewal_package_months', Number(this.bulkEdit.renewal_package_months));
                    needUpdatePrice = true;
                    needUpdateRenewalDates = true;
                }
                if (this.bulkEdit.discount_percent !== '') {
                    this.$set(item, 'discount_percent', Number(this.bulkEdit.discount_percent));
                    needUpdatePrice = true;
                }
                if (this.bulkEdit.additional_discount !== '') {
                    this.$set(item, 'additional_discount', Number(this.bulkEdit.additional_discount));
                    needUpdatePrice = true;
                }
                if (this.bulkEdit.gifted_months !== '') {
                    this.$set(item, 'gifted_months', Number(this.bulkEdit.gifted_months));
                    needUpdatePrice = true;
                    needUpdateRenewalDates = true;
                }
                if (hasBulkRenewalNextDate) {
                    savedRenewalNextDate = this.bulkEdit.renewal_next_date;
                    this.$set(item, 'renewal_next_date', savedRenewalNextDate);
                }
                if (this.bulkEdit.vnpt_monthly_price !== '') {
                    this.$set(item, 'vnpt_monthly_price', Number(this.bulkEdit.vnpt_monthly_price));
                }
                if (this.bulkEdit.manual_discount_amount !== '') {
                    this.$set(item, 'manual_discount_amount', Number(this.bulkEdit.manual_discount_amount));
                    this.updateVnptPrice(item);
                } else if (needUpdatePrice) {
                    this.updateVnptPrice(item);
                }
                
                // Tính lại các ngày gia hạn nếu có thay đổi số tháng gia hạn hoặc số tháng được tặng
                if (needUpdateRenewalDates) {
                    this.calculateRenewalEndDate(item);
                    // Nếu đã nhập renewal_next_date trong bulk edit, khôi phục lại giá trị đã nhập
                    if (hasBulkRenewalNextDate && savedRenewalNextDate) {
                        this.$set(item, 'renewal_next_date', savedRenewalNextDate);
                    }
                }
            });

            // Reset bulk edit form
            this.bulkEdit = {
                renewal_package_months: '',
                discount_percent: '',
                additional_discount: '',
                gifted_months: '',
                renewal_next_date: '',
                vnpt_monthly_price: '',
                manual_discount_amount: '',
                datePickerOpen: false
            };

            this.$swal.fire('Thành công', 'Đã áp dụng chỉnh sửa cho tất cả dòng được chọn', 'success');
        },
        formatDateForInput(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        },
        updateVnptPrice(item) {
            const price = Number(item.price) || 0;
            const manualDiscountAmount = item.manual_discount_amount !== undefined && item.manual_discount_amount !== '' && item.manual_discount_amount !== null
                ? Number(item.manual_discount_amount)
                : null;
            if (manualDiscountAmount !== null && manualDiscountAmount > 0) {
                this.$set(item, 'vnpt_monthly_price', Math.round(price - manualDiscountAmount));
            } else {
                this.$set(item, 'vnpt_monthly_price', this.calculateVnptPrice(item));
            }
        },
        async saveManualDiscountAmount(item) {
            try {
                // Cho phép xóa hết, nếu empty string thì set thành null
                if (item.manual_discount_amount === '' || item.manual_discount_amount === undefined) {
                    item.manual_discount_amount = null;
                }
                
                this.updateVnptPrice(item);
                const updateData = {
                    manual_discount_amount: item.manual_discount_amount !== undefined && item.manual_discount_amount !== '' && item.manual_discount_amount !== null 
                        ? Number(item.manual_discount_amount) 
                        : null,
                    vnpt_monthly_price: item.vnpt_monthly_price || this.calculateVnptPrice(item)
                };
                await api.updateInternet(item._id, updateData);
            } catch (error) {
                console.error("Lỗi cập nhật số tiền được giảm:", error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi cập nhật số tiền được giảm', 'error');
            }
        },
        // Tính toán đơn giá VNPT dựa vào công thức từ EditPrice.vue
        calculateVnptPrice(item) {
            const price = Number(item.price) || 0;
            const manualDiscountAmount = item.manual_discount_amount !== undefined && item.manual_discount_amount !== '' && item.manual_discount_amount !== null
                ? Number(item.manual_discount_amount)
                : null;
            
            // Nếu manual_discount_amount là số (kể cả 0) thì dùng công thức mới
            if (manualDiscountAmount !== null) {
                return Math.round(price - manualDiscountAmount);
            }
            
            const renewalMonths = Number(item.renewal_package_months) || 1;
            const giftedMonths = Number(item.gifted_months) || 0;
            const discountPercent = Number(item.discount_percent) || 0;
            const additionalDiscount = Number(item.additional_discount) || 0;
            const nearestRenewalDate = item.renewal_start_date;

            // Tính tỷ lệ cơ bản
            const baseRatio = renewalMonths / (renewalMonths + giftedMonths);
            const baseAmount = price * baseRatio;

            // Kiểm tra năm của Ngày bắt đầu gia hạn
            let discountAmount = 0;

            const renewalYear = nearestRenewalDate && new Date(nearestRenewalDate).getFullYear();

            if (renewalYear === 2024) {
                // Công thức cho năm 2024
                const discountRatio = discountPercent / 100;
                const additionalRatio = additionalDiscount / 100;

                discountAmount = baseAmount * discountRatio +
                    baseAmount * (1 - discountRatio) * additionalRatio;
            } else {
                // Công thức cho các năm khác
                discountAmount = (baseAmount / 1.1) * (additionalDiscount / 100);
            }

            // Công thức: (Giá gói cước * Gói gia hạn (tháng) / (Gói gia hạn (tháng) + Số tháng được tặng)) - Tổng cộng số tiền giảm
            const vnptPrice = baseAmount - discountAmount;

            return Math.round(vnptPrice);
        },
        toggleSelectAll() {
            if (this.selectAll) {
                this.selected_items = this.grouped_items.map(item => item._id);
            } else {
                this.selected_items = [];
            }
            this.$emit('selection-changed', this.selected_items.length);
        },
        async updateOnly() {
            await this.processUpdate(false);
        },
        async confirmRenewal() {
            await this.processUpdate(true);
        },
        async processUpdate(shouldRenew = false) {
            try {
                const promises = this.modalItems.map(item => {
                    const updateData = {};

                    // Chỉ update những field có giá trị và không rỗng
                    if (item.renewal_package_months !== undefined && item.renewal_package_months !== '' && item.renewal_package_months !== null) {
                        updateData.renewal_package_months = Number(item.renewal_package_months);
                    }
                    if (item.discount_percent !== undefined && item.discount_percent !== '' && item.discount_percent !== null) {
                        updateData.discount_percent = Number(item.discount_percent);
                    }
                    if (item.additional_discount !== undefined && item.additional_discount !== '' && item.additional_discount !== null) {
                        updateData.additional_discount = Number(item.additional_discount);
                    }
                    if (item.gifted_months !== undefined && item.gifted_months !== '' && item.gifted_months !== null) {
                        updateData.gifted_months = Number(item.gifted_months);
                    }
                    if (item.manual_discount_amount !== undefined && item.manual_discount_amount !== '' && item.manual_discount_amount !== null) {
                        updateData.manual_discount_amount = Number(item.manual_discount_amount);
                    }
                    updateData.vnpt_monthly_price = this.calculateVnptPrice(item);
                    if (item.vnpt_monthly_price !== undefined && item.vnpt_monthly_price !== '' && item.vnpt_monthly_price !== null) {
                        updateData.vnpt_monthly_price = Number(item.vnpt_monthly_price);
                    }

                    // Chỉ cập nhật các ngày gia hạn khi bấm "Chỉnh sửa và gia hạn" (shouldRenew = true)
                    if (shouldRenew) {
                        // Tính toán Ngày kết thúc gia hạn
                        const renewalMonths = Number(item.renewal_package_months) || 0;
                        const giftedMonths = Number(item.gifted_months) || 0;
                        const totalMonths = renewalMonths + giftedMonths;

                        // Tìm item gốc từ selectedItemsObjects để lấy renewal_end_date gốc từ database
                        const originalItem = this.selectedItemsObjects.find(orig => orig._id === item._id);
                        const originalRenewalEndDate = originalItem && originalItem.renewal_end_date 
                            ? originalItem.renewal_end_date 
                            : null;

                        // Ngày bắt đầu gia hạn mới = ngày kết thúc gia hạn cũ (từ database, ISO) hoặc hôm nay
                        const renewalStartMoment = originalRenewalEndDate ? moment(originalRenewalEndDate) : null;
                        const renewalStartDate =
                            renewalStartMoment && renewalStartMoment.isValid()
                                ? renewalStartMoment.toDate()
                                : new Date();
                        updateData.renewal_start_date = renewalStartDate.toISOString();

                        // Ngày kết thúc gia hạn = ngày bắt đầu + (số tháng gia hạn + số tháng được tặng)
                        const renewalEndDate = moment(renewalStartDate).clone().add(totalMonths, 'months').toDate();
                        updateData.renewal_end_date = renewalEndDate.toISOString();

                        // Ngày gia hạn tiếp theo: trong modal luôn là YYYY-MM-DD
                        if (item.renewal_next_date && item.renewal_next_date !== '') {
                            const mNext = moment(item.renewal_next_date, 'YYYY-MM-DD', true);
                            if (mNext.isValid()) {
                                updateData.renewal_next_date = mNext.toDate().toISOString();
                            } else {
                                const nextRenewalDate = moment(renewalEndDate).subtract(1, 'day').toDate();
                                updateData.renewal_next_date = nextRenewalDate.toISOString();
                            }
                        } else {
                            const nextRenewalDate = moment(renewalEndDate).subtract(1, 'day').toDate();
                            updateData.renewal_next_date = nextRenewalDate.toISOString();
                        }
                    }
                    // Nếu shouldRenew = false (chỉnh sửa không gia hạn): KHÔNG cập nhật các ngày gia hạn

                    // Chỉ gọi API nếu có dữ liệu để update
                    if (Object.keys(updateData).length > 0) {
                        return api.updateInternet(item._id, updateData);
                    }
                    return Promise.resolve();
                });

                await Promise.all(promises);

                const actionText = shouldRenew ? 'cập nhật và gia hạn' : 'cập nhật thông tin';
                swal.fire('Thành công', `Đã ${actionText} cho ${this.modalItems.length} user thành công`, 'success');

                this.renewal_dialog = false;
                this.modalItems = [];
                this.selected_items = [];

                this.getData();
            } catch (error) {
                console.error("Lỗi cập nhật:", error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi cập nhật thông tin', 'error');
            }
        },
        startExportCSV() {
            const XLSX = require('xlsx');
            
            const rows = this.grouped_items.map((item, index) => {
                return {
                    "STT": index + 1,
                    "USER": item.user,
                    "Ngày bắt đầu gia hạn": this.formatDateToLocalString(item.renewal_start_date),
                    "Ngày kết thúc gia hạn": this.formatDateToLocalString(item.renewal_end_date),
                    "NGÀY GIA HẠN TIẾP THEO": this.formatDateToLocalString(item.renewal_next_date),
                    "TRẠNG THÁI": this.internet_status[item.status].text,
                    "TÊN GÓI CƯỚC": item.package_name || '',
                    "Tốc độ (Mbps)": item.speed_mbps || '',
                    "GIÁ GÓI CƯỚC": item.price,
                    "CHIẾT KHẤU": (item.discount_percent || 0) + '%',
                    "GIẢM": (item.additional_discount || 0) + '%',
                    "SỐ TIỀN ĐƯỢC GIẢM": item.manual_discount_amount || 0,
                    "GIÁ SAU KHI CK VÀ GIẢM": Math.round(item.vnpt_monthly_price || this.calculateVnptPrice(item)),
                    "SỐ THÁNG GIA HẠN": item.renewal_package_months || '',
                    "SỐ THÁNG ĐƯỢC TẶNG": item.gifted_months || '',
                    "TÒA NHÀ": item.building_text,
                    "PHÒNG HIỆN TẠI": item.room_id
                };
            });

            // Tạo workbook và worksheet
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(rows);
            
            // Tô màu header
            const headerRange = XLSX.utils.decode_range(ws['!ref']);
            for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
                if (!ws[cellAddress]) ws[cellAddress] = { v: '' };
                ws[cellAddress].s = {
                    fill: { fgColor: { rgb: "4472C4" } },
                    font: { color: { rgb: "FFFFFF" }, bold: true },
                    alignment: { horizontal: "center", vertical: "center" }
                };
            }
            
            // Tô màu dữ liệu xen kẽ
            for (let row = 1; row <= headerRange.e.r; row++) {
                for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                    if (!ws[cellAddress]) ws[cellAddress] = { v: '' };
                    
                    if (row % 2 === 0) {
                        ws[cellAddress].s = {
                            fill: { fgColor: { rgb: "F2F2F2" } },
                            alignment: { horizontal: "center", vertical: "center" }
                        };
                    } else {
                        ws[cellAddress].s = {
                            fill: { fgColor: { rgb: "FFFFFF" } },
                            alignment: { horizontal: "center", vertical: "center" }
                        };
                    }
                }
            }
            
            // Auto-fit columns
            const colWidths = [];
            for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                let maxWidth = 10;
                for (let row = 0; row <= headerRange.e.r; row++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                    if (ws[cellAddress] && ws[cellAddress].v) {
                        const cellValue = String(ws[cellAddress].v);
                        maxWidth = Math.max(maxWidth, cellValue.length);
                    }
                }
                colWidths.push({ wch: maxWidth + 2 });
            }
            ws['!cols'] = colWidths;
            
            // Thêm worksheet vào workbook
            XLSX.utils.book_append_sheet(wb, ws, "Gia hạn Internet");
            
            // Xuất file
            const date = this.formatDateToLocalString(new Date());
            XLSX.writeFile(wb, `gia-han-internet-${date}.xlsx`);
        }
    }
};
</script>

<style scoped>
.internet-renewal-table {
    overflow-x: auto;
}

.custom-data-table tr td:nth-child(1),
.custom-data-table tr th:nth-child(1) {
    left: 0;
}

.custom-data-table tr td:nth-child(2),
.custom-data-table tr th:nth-child(2) {
    left: 50px;
}

.custom-data-table tr td:nth-child(3),
.custom-data-table tr th:nth-child(3) {
    left: 100px;
}

.custom-data-table td:nth-child(1),
.custom-data-table td:nth-child(2),
.custom-data-table td:nth-child(3),
.custom-data-table th:nth-child(3),
.custom-data-table th:nth-child(2),
.custom-data-table th:nth-child(1) {
    position: sticky;
    z-index: 1;
    background-color: white;
}

.v-table__overflow {
    overflow: unset !important;
}

.custom-data-table {
    position: relative !important;
    max-height: 70vh !important;
    overflow-y: auto !important;
}

.custom-data-table>>>.v-table,
.custom-data-table>>>.v-table__overflow,
.custom-data-table>>>.v-data-table__wrapper {
    overflow: visible !important;
}

tr.first-header {
    position: sticky !important;
    z-index: 2 !important;
    top: 0 !important;
}

.header-blue {
    background-color: #e3f2fd !important;
    color: #1976d2 !important;
}

.header-pink {
    background-color: #fce4ec !important;
    color: #c2185b !important;
}

.header-green {
    background-color: #e8f5e8 !important;
    color: #2e7d32 !important;
}

.header-yellow {
    background-color: #fff8e1 !important;
    color: #f57c00 !important;
}

.header-orange {
    background-color: #fff3e0 !important;
    color: #ef6c00 !important;
}

.header-blue {
    background-color: #e3f2fd !important;
}

.header-pink {
    background-color: #fce4ec !important;
}

.header-green {
    background-color: #e8f5e8 !important;
}

.header-yellow {
    background-color: #fff8e1 !important;
}

.header-orange {
    background-color: #fff3e0 !important;
}

.table-container {
    overflow-x: auto;
    max-width: 100%;
    height: 300px;
}

.renewal-table {
    min-width: 1000px;
}

.total-row {
    background-color: #f5f5f5 !important;
    font-weight: bold;
}

.renewal-table .v-table {
    overflow: visible !important;
}

/* CSS cho badge màu sắc */
.v-badge.error {
    background-color: #f44336 !important;
    color: white !important;
}

.v-badge.success {
    background-color: #4caf50 !important;
    color: white !important;
}

.v-badge.warning {
    background-color: #ff9800 !important;
    color: white !important;
}

.v-badge.info {
    background-color: #2196f3 !important;
    color: white !important;
}

.total-row {
    background-color: #f5f5f5 !important;
    border-top: 2px solid #1976d2 !important;
}

.total-row td {
    padding: 12px 8px !important;
    font-size: 14px !important;
}
</style>
